<template>
    <div class="notification-container">
        <transition-group name="toast">
            <div v-for="notification in store.notifications" :key="notification.id" class="toast"
                :class="['toast--' + notification.type]" @click="store.removeNotification(notification.id)">
                <div class="toast__content">
                    {{ notification.message }}
                </div>
                <button class="toast__close">&times;</button>
            </div>
        </transition-group>
    </div>
</template>

<script setup>
import { useNotificationStore } from '@/store/NotificationStore';

const store = useNotificationStore();
</script>

<style lang="scss">
.notification-container {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 99999;
    display: flex;
    flex-direction: column;
    gap: 10px;
    pointer-events: none; // Allow clicks to pass through container
}

.toast {
    pointer-events: auto; // Re-enable clicks
    min-width: 300px;
    max-width: 450px;
    padding: 16px 20px;
    border-radius: 8px;
    background: var(--color-bg);
    color: var(--color-text);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    cursor: pointer;
    border-left: 4px solid transparent;

    &__content {
        font-size: 14px;
        line-height: 1.4;
    }

    &__close {
        background: transparent;
        border: none;
        color: var(--color-text-secondary);
        font-size: 20px;
        line-height: 1;
        cursor: pointer;
        padding: 0;

        &:hover {
            color: var(--color-text);
        }
    }

    // Types
    &--success {
        border-left-color: var(--color-green);
        background: color-mix(in srgb, var(--color-green) 10%, var(--color-bg));
    }

    &--error {
        border-left-color: var(--color-red);
        background: color-mix(in srgb, var(--color-red) 10%, var(--color-bg));
    }

    &--info {
        border-left-color: var(--color-blue);
        background: color-mix(in srgb, var(--color-blue) 10%, var(--color-bg));
    }
}

// Transitions
.toast-enter-active,
.toast-leave-active {
    transition: all 0.3s ease;
}

.toast-enter-from {
    opacity: 0;
    transform: translateX(30px);
}

.toast-leave-to {
    opacity: 0;
    transform: translateX(30px);
}
</style>
